const juice = require('juice');

import { replaceInsertData } from '@ply-io/node-input-parser';
import {
	INSERT_DATA_DELIMITER_PREFIX as PREFIX,
	INSERT_DATA_DELIMITER_SUFFIX as SUFFIX,
} from '@/components/common/RichTextBox/DataChip/data-chip.const.js';

/* Private */

const PLY_SOURCE_ATTR_KEY_NAME = 'plysource';
export const excludedAttrsList = [PLY_SOURCE_ATTR_KEY_NAME];

const conversionMap = {
	href: PLY_SOURCE_ATTR_KEY_NAME,
};

function getTranslatedValue(insertedValue, previousStepsData, replaceInsertDataStringDict) {
	const valueObject = { value: PREFIX + insertedValue + SUFFIX };
	replaceInsertData([], valueObject, previousStepsData, replaceInsertDataStringDict);
	return valueObject.value;
}

function replaceAllDelimitedDataToRealValue(prefix, suffix, content, previousStepsData, replaceInsertDataStringDict) {
	content = content?.toString() || '';
	const isContentInsertedDataFromPreviousSteps = content.includes(prefix) && content.includes(suffix);
	if (!isContentInsertedDataFromPreviousSteps) {
		return content;
	}
	const builtContent = content.split(prefix).map((str) => {
		const strArr = str.split(suffix);
		if (strArr.length > 1) {
			const firstStr = strArr.shift();
			return getTranslatedValue(firstStr, previousStepsData, replaceInsertDataStringDict);
		} else {
			return `${strArr.join('')}`;
		}
	});
	return builtContent.join('');
}

/* Public */

function toTipTapHtmlAttributes(val, previousStepsData, replaceInsertDataStringDict) {
	if (!val || !previousStepsData) {
		return val || '';
	}
	const parser = new DOMParser();
	const root = parser.parseFromString(val, 'text/html');
	const nodesList = Array.from(root.querySelectorAll('*'));

	nodesList.map((childNode) => {
		let nodeAttrs = {};
		const childAttrs = childNode.getAttributeNames();
		childAttrs.map((attrName) => (nodeAttrs = { ...nodeAttrs, [attrName]: childNode.getAttribute(attrName) }));

		for (const [key, value] of Object.entries(nodeAttrs)) {
			if (value.includes(PREFIX) && value.includes(SUFFIX) && !excludedAttrsList.includes(key.toLowerCase())) {
				childNode.setAttribute(
					key,
					replaceAllDelimitedDataToRealValue(PREFIX, SUFFIX, value, previousStepsData, replaceInsertDataStringDict)
				);
			}
			if (Object.keys(conversionMap).includes(key.toLowerCase())) {
				childNode.setAttribute(conversionMap[key], `${value}`);
			}
		}
	});
	return root.documentElement?.getElementsByTagName('body')[0]?.innerHTML || '';
}

function fromTipTapHtmlAttributes(documentString) {
	const parser = new DOMParser();
	const root = parser.parseFromString(documentString, 'text/html');
	const nodesList = Array.from(root.querySelectorAll('*'));

	nodesList.map((childNode) => {
		let nodeAttrs = {};
		const childAttrs = childNode.getAttributeNames();
		childAttrs.map((attrName) => (nodeAttrs = { ...nodeAttrs, [attrName]: childNode.getAttribute(attrName) }));

		for (const [key, value] of Object.entries(nodeAttrs)) {
			if (Object.values(conversionMap).includes(key)) {
				const originalAttr = Object.keys(conversionMap).find((k) => conversionMap[k] === key);
				// set attribute to original value with tags (e.g. {{value}})
				childNode.setAttribute(originalAttr, `${value}`);
				childNode.removeAttribute(key);
			}
		}
	});
	return root.documentElement?.getElementsByTagName('body')[0]?.innerHTML || '';
}

function inlineCssToHtmlElements(htmlDocument) {
	const options = {
		applyStyleTags: true,
		removeStyleTags: true,
		inlinePseudoElements: true,
		preserveMediaQueries: false,
		preserveImportant: true,
		preserveFontFaces: false,
		preserveKeyFrames: false,
		preservePseudos: false,
	};
	const html = juice(htmlDocument, options);
	return html;
}

const HtmlDocumentService = {
	toTipTapHtmlAttributes,
	fromTipTapHtmlAttributes,
	inlineCssToHtmlElements,
};

export default HtmlDocumentService;
